import { Inputs, validationSchema } from '@/entities/Users/UserFormInputs';

const UsersForm = {
	Plural: 'Users',
	Single: 'User',
	Inputs: Inputs,
	ValidationSchema: validationSchema,
	SaveCallBack: (id) => {
		// modal form - no redirect needed
	},
};

export default UsersForm;
